import React from 'react';
import translations from '../../localization/translate.asw.json';
import { PredefinedColors } from '@ionic/core';
import { useTranslate } from '../../hooks/context/useTranslate';

export type MessageId = keyof typeof translations;

interface IMessageProps {
  id: string;
  as?: keyof React.JSX.IntrinsicElements;
  className?: string;
  color?: PredefinedColors;
}

export default function Message({
  id,
  as: Element = 'span',
  className,
}: IMessageProps) {
  const { t } = useTranslate();
  return <Element className={className}>{t(id)}</Element>;
}
